var $5d23dfb5f9514107$exports = {};
$5d23dfb5f9514107$exports = {
    "info": `Info`,
    "negative": `Fel`,
    "positive": `Lyckades`
};


export {$5d23dfb5f9514107$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
